import { tv } from "tailwind-variants";

const spinnerStyles = tv({
  base: "animate-spin rounded-full border-2 border-muted-fg/20 border-t-primary",
  variants: {
    size: {
      sm: "size-4",
      md: "size-6",
      lg: "size-10",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export type SpinnerSize = "sm" | "md" | "lg";

export interface SpinnerProps {
  /** Size variant. */
  size?: SpinnerSize;
  /** Accessible label for screen readers. @default "Loading…" */
  label?: string;
  /** Additional CSS classes. */
  className?: string;
}

export function Spinner({ size = "md", label = "Loading…", className }: SpinnerProps) {
  return (
    <output className="inline-flex items-center justify-center" aria-live="polite">
      <div className={spinnerStyles({ size, className })} />
      <span className="sr-only">{label}</span>
    </output>
  );
}
